import React from 'react'
import {
    withRouter,
    Redirect
} from 'react-router-dom'
import 'babel-polyfill';
import { Doughnut, Line } from 'react-chartjs-2';
import moment from 'moment-timezone'
import Page from './Page'
import '../styles/global.css'
import NumberHelpers from '../helpers/NumberHelpers'
import Header from '../containers/HeaderContainer';

const bundleSaleColours = [
    "#1d4ed8",
    "#06b6d4",
    "#10b981",
    "#f59e0b",
    "#ef4444",
    "#8b5cf6",
    "#ec4899",
    "#0f172a"
]

function isRefundedPurchase(purchase) {
    if (!purchase) return false
    if (purchase.refunded === true) return true
    if (purchase.refund === true) return true
    if (purchase.voided === true) return true
    if (purchase.refundedAt || purchase.refundDate || purchase.refundId) return true
    if (purchase.status && String(purchase.status).toLowerCase() === 'refunded') return true
    return false
}

function formatCurrency(value) {
    return `$${Number(value || 0).toFixed(2)}`
}

function formatDateTime(value) {
    if (!value) return "Not set"
    return moment(value).tz("Australia/Adelaide").format("DD MMM YYYY h:mma")
}

function formatDuration(startDate, endDate) {
    if (!startDate || !endDate) return "Not available"
    const duration = moment.duration(moment(endDate).diff(moment(startDate)))
    const days = Math.abs(Math.floor(duration.asDays()))
    duration.subtract(moment.duration(days, 'days'))
    const hours = Math.abs(duration.hours())
    duration.subtract(moment.duration(hours, 'hours'))
    const minutes = Math.abs(duration.minutes())
    return `${days}d ${hours}h ${minutes}m`
}

function MetricCard({ label, value, accent, hint }) {
    const valueText = String(value == null ? "" : value)
    const compactValue = valueText.length > 18
    const ultraCompactValue = valueText.length > 28

    return (
        <div className="min-w-0 rounded-[24px] border border-slate-200/80 bg-white px-4 py-4 shadow-[0_20px_45px_-30px_rgba(15,23,42,0.45)]">
            <p className="text-[11px] font-semibold uppercase tracking-[0.28em] text-slate-400">{label}</p>
            <p
                className={[
                    "mt-2 min-w-0 overflow-hidden break-words font-black leading-[1.02] tracking-[-0.04em]",
                    ultraCompactValue ? "text-[1.35rem] sm:text-[1.55rem]" : compactValue ? "text-[1.6rem] sm:text-[1.85rem]" : "text-[1.95rem] sm:text-[2.2rem]",
                    valueText.includes("_") || valueText.length > 14 ? "break-all" : "",
                    accent || "text-slate-950"
                ].join(" ").trim()}
            >
                {value}
            </p>
            {hint ? <p className="mt-2 text-[13px] leading-5 text-slate-500">{hint}</p> : null}
        </div>
    )
}

class Report extends Page {

    state = {
        busy: false,
        data: null,
        checkingUser: true,
        attendance: "",
        winnersName: "",
        rate: ""
    }

    componentDidMount() {
        window.scrollTo(0, 0)
        let self = this
        this._fetchReport = this._fetchReport.bind(this)
        this._generatePDF = this._generatePDF.bind(this)
        if (!this.props.user) {
            this.setState({ checkingUser: true }, () => {
                self.props.checkUserSession(() => {
                    self.setState({ checkingUser: false })
                    self._fetchReport()
                })
            })
        } else {
            self.setState({ checkingUser: false }, () => {
                self._fetchReport()
            })

        }
    }

    _fetchReport() {
        let self = this
        let pathArr = self.props.location.pathname.split("/")
        let clientId = pathArr[pathArr.length - 2]
        let eventId = pathArr[pathArr.length - 1]
        self.setState({ busy: true, eventId: eventId }, () => {
            self.props.fetchEventReport(clientId, eventId, (data) => {
                self.setState({ busy: false, data: data })
            })
        })
    }

    _generatePDF() {
        let self = this

        let salesData = []
        let salesLabels = []
        let bundleSaleAmounts = []
        let bundleSaleLabels = []
        let bundleSalesDict = {}
        let purchasesDict = {}
        let winner = {}
        let refundedPurchaseCount = 0
        let refundedAmount = 0

        let firstTicketSold, lastTicketSold

        if (this.state.data.purchases) {
            for (let i = 0; i < this.state.data.purchases.length; i++) {
                const purchase = this.state.data.purchases[i]
                const isRefunded = isRefundedPurchase(purchase)
                let asDate = new Date(this.state.data.purchases[i].dateCreated)
                if (!firstTicketSold || asDate < firstTicketSold) firstTicketSold = asDate
                if (!lastTicketSold || asDate > lastTicketSold) lastTicketSold = asDate
                if (isRefunded) {
                    refundedPurchaseCount += 1
                    refundedAmount += Number(purchase.refundAmount || purchase.cost || 0)
                }
                for (let j = 0; j < this.state.data.purchases[i].ticketCount; j++) {
                    if (this.state.data.purchases[i].ticketIndex + j === this.state.data.event.winningTicket) winner.phone = this.state.data.purchases[i].phone
                }
                if (isRefunded) continue
                if (bundleSalesDict[this.state.data.purchases[i].cost]) {
                    bundleSalesDict[this.state.data.purchases[i].cost] += 1;
                } else {
                    bundleSalesDict[this.state.data.purchases[i].cost] = 1;
                }

                var m = moment(new Date(self.state.data.purchases[i].dateCreated));
                var roundDown = m.startOf('date');
                if (purchasesDict[roundDown]) {
                    purchasesDict[roundDown] += self.state.data.purchases[i].cost;
                } else {
                    purchasesDict[roundDown] = self.state.data.purchases[i].cost;
                }
            }
        }
        for (var b in bundleSalesDict) {
            bundleSaleLabels.push(bundleSalesDict[b] + " x $" + b)
            bundleSaleAmounts.push(bundleSalesDict[b])
        }
        let purchasesArr = []

        for (var key in purchasesDict) {
            purchasesArr.push({
                x: key,
                y: purchasesDict[key]
            })
        }
        purchasesArr.sort(function (b, a) {
            a = new Date(a.x);
            b = new Date(b.x);
            return a > b ? -1 : a < b ? 1 : 0;
        });
        for (let i = 0; i < purchasesArr.length; i++) {
            salesData.push(purchasesArr[i])
            salesLabels.push(moment(purchasesArr[i].x).tz("Australia/Adelaide").format("DD MMM"))
        }

        let data = {
            event: self.state.data.event,
            client: self.state.data.client,
            attendance: self.state.attendance,
            winnersName: self.state.winnersName,
            rate: self.state.rate / 100,
            salesData: salesData,
            salesLabels: salesLabels,
            bundleSaleAmounts: bundleSaleAmounts,
            bundleSaleLabels: bundleSaleLabels,
            winner: winner,
            firstTicketSold: firstTicketSold,
            lastTicketSold: lastTicketSold,
            refundedPurchaseCount: refundedPurchaseCount,
            refundedAmount: refundedAmount
        }
        let base64 = btoa(JSON.stringify(data))
        let path = "https://admin.s50.events/pdf/?data=" + base64

        self.setState({ generatingPdf: true }, () => {
            self.props.generatePDF(path, (res) => {
                if (res.url) {
                    var element = document.createElement('a');
                    element.setAttribute('href', res.url);
                    element.setAttribute('download', self.state.eventId + ".pdf");
                    element.setAttribute('target', "_blank");
                    element.style.display = 'none';
                    document.body.appendChild(element);
                    element.click();
                    document.body.removeChild(element);
                }
                self.setState({ generatingPdf: false })
            })
        })
    }

    render() {
        let self = this

        if (self.state.checkingUser || self.state.busy) {
            return (
                <div className="wrapper">
                    <div className="container-fluid">
                        <div className="text-center v-margin-20">
                            <img src="/images/loaders/oval.svg" alt="Loading" />
                        </div>
                    </div>
                </div>
            )
        }

        if (!this.props.user) {
            return <Redirect to='/' />
        }

        if (!self.state.data || !self.state.data.event) {
            return (
                <div>
                    <Header />
                    <div className="mx-auto max-w-7xl px-6 py-10">
                        <div className="rounded-[28px] border border-slate-200 bg-white p-8 text-center text-slate-500 shadow-[0_20px_45px_-30px_rgba(15,23,42,0.45)]">
                            Event not found.
                        </div>
                    </div>
                </div>
            )
        }

        const csvArr = [["eventId", "ticketId", "datePurchased", "transactionId", "phone", "email", "optIn", "winner", "refunded", "refundedAt", "refundAmount", "refundReason", "refundId"]]
        const winner = this.state.data.event.completed ? {} : null
        const bundleSalesDict = {}
        const purchasesDict = {}
        let refundedPurchaseCount = 0
        let refundedAmount = 0

        const startMoment = moment(new Date(self.state.data.event.startDate)).startOf('date')
        const endMoment = moment(self.state.data.event.completed ? new Date(self.state.data.event.endDate) : new Date()).startOf('date')
        const dayDiff = Math.abs(startMoment.diff(endMoment, 'days'))
        for (let k = 0; k <= dayDiff; k++) {
            const n = moment(startMoment).add(k, "days")
            purchasesDict[n.toISOString()] = 0
        }

        if (this.state.data.purchases) {
            for (let i = 0; i < this.state.data.purchases.length; i++) {
                const purchase = this.state.data.purchases[i]
                const isRefunded = isRefundedPurchase(purchase)
                if (isRefunded) {
                    refundedPurchaseCount += 1
                    refundedAmount += Number(purchase.refundAmount || purchase.cost || 0)
                }
                for (let j = 0; j < this.state.data.purchases[i].ticketCount; j++) {
                    const ticketNumber = this.state.data.purchases[i].ticketIndex + j
                    const arr = []
                    arr.push(this.state.data.event.SK)
                    arr.push(this.state.data.event.SK + "_" + NumberHelpers.pad(ticketNumber, 3))
                    arr.push(this.state.data.purchases[i].dateCreated)
                    arr.push(this.state.data.purchases[i].transactionId)
                    arr.push(this.state.data.purchases[i].phone)
                    arr.push(this.state.data.purchases[i].email)
                    arr.push(this.state.data.purchases[i].optIn)
                    arr.push(ticketNumber === this.state.data.event.winningTicket)
                    arr.push(isRefunded)
                    arr.push(this.state.data.purchases[i].refundedAt || this.state.data.purchases[i].refundDate || "")
                    arr.push(this.state.data.purchases[i].refundAmount || "")
                    arr.push(this.state.data.purchases[i].refundReason || "")
                    arr.push(this.state.data.purchases[i].refundId || "")
                    if (ticketNumber === this.state.data.event.winningTicket) winner.phone = this.state.data.purchases[i].phone
                    csvArr.push(arr)
                }
                if (isRefunded) continue
                if (bundleSalesDict[this.state.data.purchases[i].cost]) {
                    bundleSalesDict[this.state.data.purchases[i].cost] += 1;
                } else {
                    bundleSalesDict[this.state.data.purchases[i].cost] = 1;
                }
                const roundDown = moment(new Date(self.state.data.purchases[i].dateCreated)).startOf('date').toISOString()
                if (purchasesDict[roundDown] || purchasesDict[roundDown] === 0) {
                    purchasesDict[roundDown] += self.state.data.purchases[i].cost;
                } else {
                    purchasesDict[roundDown] = self.state.data.purchases[i].cost;
                }
            }
        }

        const bundleEntries = Object.keys(bundleSalesDict)
            .sort((a, b) => Number(a) - Number(b))
            .map((price, index) => ({
                label: `${bundleSalesDict[price]} x $${price}`,
                amount: bundleSalesDict[price],
                color: bundleSaleColours[index % bundleSaleColours.length]
            }))

        const purchasesArr = Object.keys(purchasesDict).map((key) => ({
            x: key,
            y: purchasesDict[key]
        })).sort((a, b) => new Date(a.x) - new Date(b.x))

        const salesLabels = purchasesArr.map((point) => moment(point.x).tz("Australia/Adelaide").format("DD MMM"))
        const salesData = purchasesArr.map((point) => point.y)

        const csvContent = "data:text/csv;charset=utf-8," + csvArr.map((rowArray) => rowArray.join(",")).join("\r\n")
        const csv = encodeURI(csvContent)

        const grossSales = Number(self.state.data.event.prizePool || 0) + refundedAmount
        const splitRate = Number(self.state.rate || 0) / 100
        const winnerAmount = Number(self.state.data.event.prizePool || 0) * 0.5
        const splitAmount = Number(self.state.data.event.prizePool || 0) * splitRate
        const clientAmount = winnerAmount - splitAmount

        const lineOptions = {
            maintainAspectRatio: false,
            legend: {
                display: false
            },
            tooltips: {
                backgroundColor: '#0f172a',
                titleFontColor: '#f8fafc',
                bodyFontColor: '#cbd5e1',
                displayColors: false,
                callbacks: {
                    label: (tooltipItem) => formatCurrency(tooltipItem.yLabel)
                }
            },
            scales: {
                yAxes: [{
                    ticks: {
                        beginAtZero: true,
                        fontColor: '#64748b',
                        callback: (value) => `$${value}`
                    },
                    gridLines: {
                        color: 'rgba(148, 163, 184, 0.18)',
                        zeroLineColor: 'rgba(148, 163, 184, 0.18)'
                    }
                }],
                xAxes: [{
                    ticks: {
                        fontColor: '#64748b'
                    },
                    gridLines: {
                        display: false
                    }
                }]
            }
        }

        const doughnutOptions = {
            maintainAspectRatio: false,
            cutoutPercentage: 68,
            legend: {
                position: 'bottom',
                labels: {
                    fontColor: '#334155',
                    boxWidth: 12,
                    padding: 16
                }
            },
            tooltips: {
                backgroundColor: '#0f172a',
                titleFontColor: '#f8fafc',
                bodyFontColor: '#cbd5e1'
            }
        }

        const eventLink = `/events/${self.state.data.event.PK}`

        return (
            <div className="min-h-screen lg:flex">
                <Header />
                <main className="min-w-0 flex-1 px-4 py-4 sm:px-6 lg:px-10 lg:py-8">
                    <div className="mx-auto max-w-7xl">
                    <section className="rounded-[32px] border border-slate-200/80 bg-white px-8 py-8 shadow-[0_24px_60px_-35px_rgba(15,23,42,0.45)]">
                        <div className="flex flex-col gap-6 lg:flex-row lg:items-start lg:justify-between">
                            <div className="space-y-4">
                                <a href={eventLink} className="text-[11px] font-semibold uppercase tracking-[0.32em] text-sky-600">Back To Event</a>
                                <div>
                                    <p className="text-[11px] font-semibold uppercase tracking-[0.32em] text-slate-400">Report</p>
                                    <h1 className="mt-3 text-4xl font-black tracking-[-0.04em] text-slate-950">
                                        {self.state.data.client.name} · {self.state.data.event.SK}
                                    </h1>
                                </div>
                                <p className="max-w-3xl text-base leading-7 text-slate-600">
                                    Review raffle performance, refunded activity, ticket mix, and winner details from one cleaner analytics view.
                                </p>
                            </div>
                            <div className="flex flex-col gap-3 sm:flex-row">
                                <a
                                    href={csv}
                                    download={self.state.data.event.SK}
                                    className="inline-flex h-12 items-center justify-center rounded-full border border-slate-200 bg-white px-5 text-sm font-semibold text-slate-700 transition hover:border-slate-300 hover:text-slate-950"
                                >
                                    Download CSV
                                </a>
                                <button
                                    type="button"
                                    disabled={self.state.generatingPdf || self.state.rate === "" || self.state.attendance === "" || self.state.winnersName === ""}
                                    onClick={self._generatePDF}
                                    className="inline-flex h-12 items-center justify-center rounded-full bg-[#1cd997] px-5 text-sm font-semibold text-slate-950 transition hover:brightness-95 disabled:cursor-not-allowed disabled:bg-slate-200 disabled:text-slate-400"
                                >
                                    {self.state.generatingPdf ? "Generating..." : "Generate PDF"}
                                </button>
                            </div>
                        </div>
                    </section>

                    <section className="mt-8 grid gap-3 md:grid-cols-2 xl:grid-cols-4">
                        <MetricCard label="Prize Pool" value={formatCurrency(self.state.data.event.prizePool)} accent="text-sky-600" />
                        <MetricCard label="Tickets Sold" value={self.state.data.event.ticketCount} accent="text-slate-950" />
                        <MetricCard label="Gross Before Refunds" value={formatCurrency(grossSales)} accent="text-emerald-600" />
                        <MetricCard label="Refunded Amount" value={formatCurrency(refundedAmount)} accent="text-rose-500" hint={`${refundedPurchaseCount} refunded purchase${refundedPurchaseCount === 1 ? '' : 's'}`} />
                    </section>

                    <section className="mt-4 grid gap-3 md:grid-cols-2 xl:grid-cols-4">
                        <MetricCard label="Winning Ticket" value={self.state.data.event.completed ? `${self.state.data.event.SK}_${NumberHelpers.pad(self.state.data.event.winningTicket, 3)}` : "Pending"} accent="text-slate-950" />
                        <MetricCard label="Winner Phone" value={winner && winner.phone ? winner.phone : "Pending"} accent="text-slate-950" />
                        <MetricCard label="Start Date" value={formatDateTime(self.state.data.event.startDate)} hint={`Duration ${formatDuration(self.state.data.event.startDate, self.state.data.event.endDate || new Date())}`} />
                        <MetricCard label="Draw Date" value={formatDateTime(self.state.data.event.endDate)} hint={self.state.data.event.completed ? "Event completed" : "Live event"} />
                    </section>

                    <section className="mt-8 grid gap-6 lg:grid-cols-[1.15fr,0.85fr]">
                        <div className="rounded-[32px] border border-slate-200/80 bg-white p-6 shadow-[0_24px_60px_-35px_rgba(15,23,42,0.45)]">
                            <div className="flex items-start justify-between gap-4">
                                <div>
                                    <p className="text-[11px] font-semibold uppercase tracking-[0.32em] text-slate-400">PDF Inputs</p>
                                    <h2 className="mt-2 text-2xl font-black tracking-[-0.03em] text-slate-950">Report Settings</h2>
                                </div>
                                <span className="rounded-full bg-slate-100 px-3 py-1 text-xs font-semibold text-slate-500">Required for PDF export</span>
                            </div>
                            <div className="mt-6 grid gap-4 md:grid-cols-3">
                                <label className="block">
                                    <span className="mb-2 block text-sm font-semibold text-slate-700">Client Rate (%)</span>
                                    <input
                                        disabled={self.state.generatingPdf}
                                        type="number"
                                        className="admin-input w-full rounded-xl border border-slate-200 bg-white px-4 py-3 text-slate-900"
                                        placeholder=""
                                        value={self.state.rate}
                                        onChange={(e) => self.setState({ rate: e.target.value })}
                                    />
                                </label>
                                <label className="block">
                                    <span className="mb-2 block text-sm font-semibold text-slate-700">Attendance</span>
                                    <input
                                        disabled={self.state.generatingPdf}
                                        type="number"
                                        className="admin-input w-full rounded-xl border border-slate-200 bg-white px-4 py-3 text-slate-900"
                                        placeholder=""
                                        value={self.state.attendance}
                                        onChange={(e) => self.setState({ attendance: e.target.value })}
                                    />
                                </label>
                                <label className="block">
                                    <span className="mb-2 block text-sm font-semibold text-slate-700">Winner Name</span>
                                    <input
                                        disabled={self.state.generatingPdf}
                                        type="text"
                                        className="admin-input w-full rounded-xl border border-slate-200 bg-white px-4 py-3 text-slate-900"
                                        placeholder=""
                                        value={self.state.winnersName}
                                        onChange={(e) => self.setState({ winnersName: e.target.value })}
                                    />
                                </label>
                            </div>
                            <div className="mt-6 grid gap-4 md:grid-cols-3">
                                <MetricCard label="To Winner" value={formatCurrency(winnerAmount)} accent="text-sky-600" />
                                <MetricCard label={`To ${self.state.data.client.name}`} value={formatCurrency(clientAmount)} accent="text-emerald-600" />
                                <MetricCard label="To Split 50-50" value={formatCurrency(splitAmount)} accent="text-slate-950" />
                            </div>
                        </div>

                        <div className="rounded-[32px] border border-slate-200/80 bg-white p-6 shadow-[0_24px_60px_-35px_rgba(15,23,42,0.45)]">
                            <p className="text-[11px] font-semibold uppercase tracking-[0.32em] text-slate-400">Event Summary</p>
                            <h2 className="mt-2 text-2xl font-black tracking-[-0.03em] text-slate-950">Operational Snapshot</h2>
                            <div className="mt-6 space-y-4">
                                <div className="rounded-2xl bg-slate-50 px-4 py-4">
                                    <p className="text-xs font-semibold uppercase tracking-[0.28em] text-slate-400">First Ticket Sold</p>
                                    <p className="mt-2 text-base font-semibold text-slate-900">{formatDateTime(self.state.data.purchases && self.state.data.purchases.length ? self.state.data.purchases[0].dateCreated : self.state.data.event.startDate)}</p>
                                </div>
                                <div className="rounded-2xl bg-slate-50 px-4 py-4">
                                    <p className="text-xs font-semibold uppercase tracking-[0.28em] text-slate-400">Last Ticket Sold</p>
                                    <p className="mt-2 text-base font-semibold text-slate-900">{formatDateTime(self.state.data.purchases && self.state.data.purchases.length ? self.state.data.purchases[self.state.data.purchases.length - 1].dateCreated : self.state.data.event.endDate)}</p>
                                </div>
                                <div className="rounded-2xl bg-slate-50 px-4 py-4">
                                    <p className="text-xs font-semibold uppercase tracking-[0.28em] text-slate-400">Active Duration</p>
                                    <p className="mt-2 text-base font-semibold text-slate-900">{formatDuration(self.state.data.purchases && self.state.data.purchases.length ? self.state.data.purchases[0].dateCreated : self.state.data.event.startDate, self.state.data.purchases && self.state.data.purchases.length ? self.state.data.purchases[self.state.data.purchases.length - 1].dateCreated : self.state.data.event.endDate)}</p>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="mt-8 grid gap-6 xl:grid-cols-[1.2fr,0.8fr]">
                        <div className="rounded-[32px] border border-slate-200/80 bg-white p-6 shadow-[0_24px_60px_-35px_rgba(15,23,42,0.45)]">
                            <div className="flex items-start justify-between gap-4">
                                <div>
                                    <p className="text-[11px] font-semibold uppercase tracking-[0.32em] text-slate-400">Revenue Trend</p>
                                    <h2 className="mt-2 text-2xl font-black tracking-[-0.03em] text-slate-950">Sales Over Time</h2>
                                </div>
                                <span className="rounded-full bg-sky-50 px-3 py-1 text-xs font-semibold text-sky-700">Refunded purchases excluded</span>
                            </div>
                            <div className="mt-6 h-[320px]">
                                <Line
                                    data={{
                                        labels: salesLabels,
                                        datasets: [{
                                            label: "Sales",
                                            data: salesData,
                                            borderColor: '#0ea5e9',
                                            backgroundColor: 'rgba(14, 165, 233, 0.14)',
                                            borderWidth: 3,
                                            pointRadius: 3,
                                            pointHoverRadius: 5,
                                            lineTension: 0.35
                                        }]
                                    }}
                                    options={lineOptions}
                                />
                            </div>
                        </div>

                        <div className="rounded-[32px] border border-slate-200/80 bg-white p-6 shadow-[0_24px_60px_-35px_rgba(15,23,42,0.45)]">
                            <div>
                                <p className="text-[11px] font-semibold uppercase tracking-[0.32em] text-slate-400">Ticket Mix</p>
                                <h2 className="mt-2 text-2xl font-black tracking-[-0.03em] text-slate-950">Bundle Distribution</h2>
                            </div>
                            <div className="mt-6 h-[320px]">
                                <Doughnut
                                    data={{
                                        datasets: [{
                                            data: bundleEntries.map((entry) => entry.amount),
                                            backgroundColor: bundleEntries.map((entry) => entry.color),
                                            borderWidth: 0
                                        }],
                                        labels: bundleEntries.map((entry) => entry.label)
                                    }}
                                    options={doughnutOptions}
                                />
                            </div>
                        </div>
                    </section>
                    </div>
                </main>
            </div>
        )
    }
}

export default withRouter(Report)
